module.exports = __webpack_public_path__ + "static/media/12.25285420.png";